import React, { useEffect } from "react";
import "./success.css";
import { Link, useNavigate } from "react-router-dom";

function RegisterSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => navigate("/authentication/sign-in"), 8000);
  }, []);
  return (
    <div className="wrap-success">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-12">
            <div className="wrappersvg">
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                ></circle>
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M18.1 27.2l7.1 7.2 16.7-16.8"
                ></path>
                <path
                  className="checkmark__checks"
                  fill="none"
                  d="M11.1 28.2l7.1 7.2 16.7-16.8"
                ></path>
              </svg>
            </div>
            <h1 className="success-title text-center pt-5 text-light">
              Submitted Successfully
            </h1>
            <p className="success-desc text-center pt-2 text-light">
              Thank you for your submission. We’ll be in touch real soon!
            </p>
            <div className="d-grid gap-2 col-7 col-md-3 mx-auto mb-3">
              <Link to="/" className="btn btn-contact">
                Back to Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterSuccess;
